import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { RequiredToggle } from 'apps/builder/components/settings/modal/shared'

export const VideoField = ({ guid, required, type, label, keyField }) => (
  <>
  <div className="foundry--surface surface--info info--block">
    <p>
    Videos can cause your submission files to be larger than normal. We recommend not adding more than 3 Video fields to ensure that your submissions and data upload successfully from your users' mobile devices.
    </p>
  </div>

  <div className="settings--row no-border">
    <SettingsFieldSelect
      guid={guid}
      label={label}
      keyField={keyField}
      type={type}
    />
    <div className="toggles-group">
      <div className="toggle-wrapper">
        <RequiredToggle guid={guid} active={required} />
      </div>
    </div>
  </div>
</>
)